import styled from 'styled-components';
import { useSolana } from '../../hooks/useSolana';
import { QRCodeCanvas } from 'qrcode.react';
import { BodyLarge, BodyMedium, ParagraphLargeText } from '../Texts';
import Button from '../Button';
import CopyButton from '../CopyButton';

const QRCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60%;
`;

const AddressContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  flex-direction: column;
`;

const ContentContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const StyledCopyButton = styled(CopyButton)`
  min-width: 80px;
  transition: opacity 0.2s ease;
`;

const ReceiveCrypto = ({ onBack, buttonText = 'Back' }) => {
  const { wallets } = useSolana();

  return (
    <ContentContainer>
      <QRCodeContainer>
        <QRCodeCanvas
          value={wallets[0]?.address}
          style={{ width: '80%', height: '80%' }}
        />
      </QRCodeContainer>
      <AddressContainer>
        <div>
          <BodyLarge>Your Solana Address</BodyLarge>
          <BodyMedium>
            {wallets[0]?.address.slice(0, 4)}...{wallets[0]?.address.slice(-4)}
          </BodyMedium>
        </div>
        <StyledCopyButton
          fullWidth={true}
          textToCopy={wallets[0]?.address}
          variant='primary'
          showTextChange={true}
          defaultText='Copy'
          copiedText='Copied!'
        />
      </AddressContainer>
      {onBack && (
        <Button variant='secondary' fullWidth={true} onClick={onBack}>
          {buttonText}
        </Button>
      )}
    </ContentContainer>
  );
};

export default ReceiveCrypto;
